export default __webpack_public_path__ + "static/media/bsc-network.cb6b375e.jpg";